<template>
  <div class="edit-field-variant">
    <v-alert dense text color="orange darken-2" class="ma-3 mb-1">
      Les variantes se règlent maintenant option par option. Utilisez le petit bouton orange placé à côté de chaque paramètre pour afficher les valeurs de toutes les entreprises, créer une surcharge ou revenir à l’héritage global.
    </v-alert>
    <Field :field-id="fieldId" :context-key="contextKey" embedded @variant-saved="$emit('saved', $event)" />
  </div>
</template>

<script>
export default {
  name: 'EditFieldVariant',
  components: { Field: () => import('./Field.vue') },
  props: {
    fieldId: { type: [String, Number], required: true },
    variant: { type: [String, Number], required: true },
    contextKey: { type: String, default: '' },
    embedded: { type: Boolean, default: false },
    standalone: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.edit-field-variant { width: 100%; }
</style>
